const technicianMarker = {
  name: 'zipcodePin',
  width: 40,
  height: 52,
  svg: `
<svg width="40" height="52" viewBox="0 0 40 52" xmlns="http://www.w3.org/2000/svg">
  <polygon
    points="0,0 40,0 20,52"
    fill="#1976d2"
    stroke="#1976d2"
    stroke-width="3"
  />
</svg>
`,
};

/** Google Maps–style drop pin in red (tip at bottom center for icon-anchor: bottom) */
const technicianMarker2 = {
  name: 'technicianPin2',
  width: 40,
  height: 52,
  svg: `
<svg width="40" height="52" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax meet">
  <path
    d="M12 0C5.4 0 0 5.4 0 12c0 8 12 24 12 24s12-16 12-24C24 5.4 18.6 0 12 0z"
    fill="#EA4335"
    stroke="#C5221F"
    stroke-width="0.75"
  />
  <circle cx="12" cy="10" r="3.5" fill="#ffffff" />
</svg>
`,
};

// eslint-disable-next-line import/prefer-default-export
export { technicianMarker, technicianMarker2 };
